import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subject } from 'rxjs'
import { map, takeUntil } from 'rxjs/operators'
import { NavService } from '../nav.service'
import { Store } from '@ngrx/store'
import { AppState } from '../core/store'
import { fetchTracking } from './store/tracking.actions'
import { TrackingContainerComponent } from './tracking.container'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-tracking-route',
  template: ` <app-tracking-container /> `,
  imports: [TrackingContainerComponent],
})
export class TrackingRouteContainerComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute)
  private store = inject<Store<AppState>>(Store)

  private destroy$ = new Subject()

  ngOnInit(): void {
    this.route.paramMap.subscribe()
  }

  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
